import React, { useState } from "react";
import { IoMdClose, IoMdAdd } from "react-icons/io";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { IoCalendarClearOutline, IoTimeOutline } from "react-icons/io5";
import { PiTrashThin } from "react-icons/pi";
import { BsPencil } from "react-icons/bs";

export default function ScheduleMessage({ setActiveSection }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [messages, setMessages] = useState([
    {
      id: 1,
      recipient: "Emily Rose",
      message: "Here's to a year filled with adventure!",
      date: "2025-04-12",
      time: "00:02",
    },
    {
      id: 2,
      recipient: "Emily Rose",
      message: "Wishing you all the best on your big day!",
      date: "2025-04-13",
      time: "10:30",
    },
  ]);

  const [newMessage, setNewMessage] = useState({
    recipient: "Emily Rose",
    message: "",
    date: "2025-04-12",
    time: "00:02",
  });

  const handleAddMessage = () => {
    if (isEditing) {
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === editId ? { ...msg, ...newMessage, id: editId } : msg
        )
      );
    } else {
      const newEntry = {
        ...newMessage,
        id: Date.now(),
      };
      setMessages((prev) => [...prev, newEntry]);
    }

    // Reset modal and form
    setIsModalOpen(false);
    setIsEditing(false);
    setEditId(null);
    setNewMessage({
      recipient: "Emily Rose",
      message: "",
      date: "2025-04-12",
      time: "00:02",
    });
  };

  const handleDelete = (id) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  return (
    <section>
      <div className="sticky w-full min-h-[67px] py-2.5 bg-white flex items-center justify-between border-b text-black p-4 text-center">
        <div className="flex justify-between items-center w-full">
          <div className="w-full items-center bg-white text-black flex gap-4">
            <MdOutlineArrowBackIosNew
              onClick={() => setActiveSection("contact")}
              className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1.5 border rounded-md"
            />
            <h1 className="text-lg font-semibold text-center">
              Schedule Message
            </h1>
          </div>
          <IoMdAdd
            onClick={() => setIsModalOpen(true)}
            className="cursor-pointer hover:text-white h-8 w-8 p-1 text-white bg-[var(--primary-color)] border rounded-md"
          />
        </div>
      </div>

      <div className="bg-[#fff] h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] overflow-y-auto">
        {messages.map((msg, index) => (
          <div
            key={msg.id}
            className={`flex bg-[#f9f6fe] items-center gap-2 px-1.5 pb-1.5 ${
              index === 0 ? "pt-1.5" : ""
            }`}
          >
            <div className="bg-white rounded-lg w-full p-4">
              <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold text-sm">{msg.recipient}</p>
                  <div className="flex items-center gap-2">
                    <PiTrashThin
                      onClick={() => handleDelete(msg.id)}
                      className="cursor-pointer hover:text-black h-8 w-8 p-1 text-[#F44336] bg-white border rounded-md"
                    />
                    <BsPencil
                      onClick={() => {
                        const selected = messages.find(
                          (msg) => msg.id === msg.id
                        );
                        setNewMessage({
                          recipient: selected.recipient,
                          message: selected.message,
                          date: selected.date,
                          time: selected.time,
                        });
                        setIsEditing(true);
                        setEditId(selected.id);
                        setIsModalOpen(true);
                      }}
                      className="cursor-pointer hover:text-black h-8 w-8 p-1.5 text-[var(--primary-color)] bg-white border rounded-md"
                    />
                  </div>
                </div>
                <p className="text-sm text-gray-700 max-w-xs truncate">{msg.message}</p>
                <div className="flex justify-between items-center font-normal text-xs text-gray-500 mt-2">
                  <span>
                    {msg.date} {msg.time}
                  </span>
                  <button className="text-[#06B300] font-medium text-xs hover:underline">
                    Send now
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <dialog id="my_modal" className="modal modal-open">
          <div className="modal-box bg-white max-w-xl">
            <div className="flex justify-between items-center pb-6">
              <h3 className="font-semibold text-lg">
                {isEditing ? " Edit Schedule Message" : "New Schedule Message"}
              </h3>
              <IoMdClose
                onClick={() => setIsModalOpen(false)}
                className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
              />
            </div>

            <div className="space-y-4">
              <div>
                <label className="font-normal text-[#525252] block text-sm">
                  Recipient
                </label>
                <p className="mt-1 font-medium text-gray-700">
                  {newMessage.recipient}
                </p>
              </div>

              <div>
                <label className="font-normal text-[#525252] block text-sm mb-1.5">
                  Message
                </label>
                <input
                  type="text"
                  value={newMessage.message}
                  onChange={(e) =>
                    setNewMessage({ ...newMessage, message: e.target.value })
                  }
                  className="input bg-inherit input-bordered border border-[#EBEBEB] rounded-lg py-5  w-full"
                  placeholder="Enter Message"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="font-normal text-[#525252] block text-sm mb-1.5">
                    Send out at (Date)
                  </label>
                  <div className="relative">
                    <input
                      type="date"
                      value={newMessage.date}
                      onChange={(e) =>
                        setNewMessage({ ...newMessage, date: e.target.value })
                      }
                      className="input input-bordered bg-white border-[#EBEBEB] w-full py-3 pr-10 text-black custom-date-input"
                    />
                    {/* <IoCalendarClearOutline className="absolute right-3 top-2.5 text-gray-500 pointer-events-none text-lg" /> */}
                  </div>
                </div>

                <div>
                  <label className="font-normal text-[#525252] block text-sm mb-1.5">
                    Time
                  </label>
                  <div className="relative">
                    <input
                      type="time"
                      value={newMessage.time}
                      onChange={(e) =>
                        setNewMessage({ ...newMessage, time: e.target.value })
                      }
                      className="input input-bordered border-[#EBEBEB] bg-white rounded-lg w-full py-5 pr-10 text-black"
                    />
                    {/* <IoTimeOutline className="absolute right-3 top-3 text-gray-500 text-lg" /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-action mt-6">
              <button
                onClick={handleAddMessage}
                className="btn border-none px-10 py-5 text-white font-medium shadow-none bg-[var(--primary-color)] rounded-full"
              >
                Save
              </button>
            </div>
          </div>
        </dialog>
      )}
    </section>
  );
}
